import PurposeField from '@apps/campaigns/admin/components/purposefield'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.PureComponent {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    sms_campaign: PropTypes.object
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { sms_campaign } = this.props
    return {
      title: 't(Edit SMS Campaign)',
      method: 'PATCH',
      endpoint: `/api/admin/campaigns/sms/${sms_campaign.id}/edit`,
      action: `/api/admin/campaigns/sms/${sms_campaign.id}`,
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true },
            ...this._getCampaign()
          ]
        }
      ]
    }
  }

  _getCampaign() {
    const { sms_campaign } = this.props
    if(sms_campaign.direction === 'inbound') {
      return [
        { label: 't(Trigger Term)', name: 'term', type: 'textfield', required: true }
      ]
    } else if(sms_campaign.direction === 'outbound') {
      return [
        { label: 't(Purpose)', name: 'purpose', type: PurposeField, channel: 'sms', required: true }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Edit
